import classNames from 'classnames';

const LogoIcon = ({
  size = 48,
  backgroundColor = 'black',
  strokeColor = 'white',
  animateOnHover = false,
  animateOnMount = false,
  animateLoading = false
}: {
  size?: number;
  backgroundColor?: string;
  strokeColor?: string;
  animateOnHover?: boolean;
  animateOnMount?: boolean;
  animateLoading?: boolean;
}) => {
  // Named group (`/logo`) scopes the hover to THIS svg — a bare `group-hover` would also fire
  // for the shadcn Sidebar wrapper's `group` class, rotating the shapes on any sidebar hover.
  const hoverShapeClassName = animateOnHover
    ? 'origin-center [transform-box:fill-box] transition-transform duration-500 ease-smooth group-hover/logo:-rotate-90 motion-reduce:transition-none motion-reduce:group-hover/logo:rotate-0'
    : '';

  // Per-shape animations, gated by prop. A single instance uses at most one of these:
  // - mount: "assemble from scatter" entrance, runs once
  // - loader: sequential pulse, loops while the mentorbot is thinking
  // transform-box: fill-box scopes scale/rotate to each shape's own center.
  const shapeClassName = (mountAnimation: string, loaderAnimation: string) =>
    classNames(
      hoverShapeClassName,
      animateOnMount &&
        `origin-center [transform-box:fill-box] ${mountAnimation} motion-reduce:animate-none`,
      animateLoading &&
        `origin-center [transform-box:fill-box] ${loaderAnimation} motion-reduce:animate-none`
    ) || undefined;

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(
        animateOnHover &&
          'group/logo origin-center transition-transform duration-500 ease-smooth hover:rotate-90 motion-reduce:transition-none motion-reduce:hover:rotate-0'
      )}
    >
      <g>
        <path
          d='M40.5 0H7.5C3.35786 0 0 3.35786 0 7.5V40.5C0 44.6421 3.35786 48 7.5 48H40.5C44.6421 48 48 44.6421 48 40.5V7.5C48 3.35786 44.6421 0 40.5 0Z'
          fill={backgroundColor}
        />
        <path
          className={shapeClassName('animate-logo-assemble-tl', 'animate-logo-loader-tl')}
          d='M20.1097 9.8457H10.9065C9.78523 9.8457 8.86246 10.7077 8.86246 11.769V20.3995C8.86246 21.4574 9.78523 22.3228 10.9065 22.3228H20.1097C21.2379 22.3228 22.1537 21.4574 22.1537 20.3995V11.769C22.1537 10.711 21.2379 9.8457 20.1097 9.8457Z'
          fill={strokeColor}
        />
        <path
          className={shapeClassName('animate-logo-assemble-bl', 'animate-logo-loader-bl')}
          d='M15.2591 25.6863C11.5855 25.6863 8.61523 28.4813 8.61523 31.923C8.61523 35.3647 11.589 38.1534 15.2591 38.1534C18.9292 38.1534 21.896 35.3647 21.896 31.923C21.896 28.4813 18.9223 25.6863 15.2591 25.6863Z'
          fill={strokeColor}
        />
        <path
          className={shapeClassName('animate-logo-assemble-br', 'animate-logo-loader-br')}
          fillRule='evenodd'
          clipRule='evenodd'
          d='M35.9012 24.6152H26.8677C25.6236 24.6152 24.6152 25.6264 24.6152 26.8733V35.9027C24.6152 37.1458 25.6236 38.1537 26.8677 38.1537H35.9012C37.1453 38.1537 38.1537 37.1458 38.1537 35.9027V26.8733C38.1537 25.6301 37.1453 24.6152 35.9012 24.6152ZM36.4583 35.899C36.4583 36.2132 36.2053 36.4626 35.9012 36.4626H26.8677C26.5535 36.4626 26.3038 36.2098 26.3038 35.899V26.87C26.3038 26.5557 26.5568 26.3063 26.8677 26.3063H35.9012C36.2087 26.3063 36.4583 26.5591 36.4583 26.87V35.899Z'
          fill={strokeColor}
        />
        <path
          className={shapeClassName('animate-logo-assemble-tr', 'animate-logo-loader-tr')}
          fillRule='evenodd'
          clipRule='evenodd'
          d='M31.9997 9.8457C28.5993 9.8457 25.8457 12.6042 25.8457 16.0026C25.8457 19.4011 28.5993 22.1534 31.9997 22.1534C35.3998 22.1534 38.1534 19.4011 38.1534 16.0026C38.1534 12.6042 35.3937 9.8457 31.9997 9.8457ZM31.9997 20.6188C29.451 20.6188 27.3809 18.5468 27.3809 16.0026C27.3809 13.4585 29.4541 11.3865 31.9997 11.3865C34.545 11.3865 36.6117 13.4523 36.6117 16.0026C36.6117 18.553 34.545 20.6188 31.9997 20.6188Z'
          fill={strokeColor}
        />
      </g>
    </svg>
  );
};

export default LogoIcon;
